import { useContext } from 'react';

import { navContext } from '../contexts/navigation';
import { INavContext } from '../contexts/navigation/interfaces';

const useNavigation = () => useContext<INavContext>(navContext);

export default useNavigation;
